import i18n from "./i18n";
import { setLocale } from "yup";

setLocale({
  mixed: {
    required: ({ label }) => {
      if (label) {
        return i18n.t("{{label}} is a required field", { label });
      }
      return i18n.t("This field is required");
    },
  },
});
